import * as React from 'react';
import NumberInput from '../../Inputs/NumberInput';

const MIN_VALUE = 1;
const MAX_VALUE = 500;
const VALUE_STEP = 1;

const LocationSelector = (props: {
  value: number | null;
  onChange: (value: number | null) => void
}) => {
  const { value, onChange } = props;

  return (
    <NumberInput
      value={value}
      onChange={onChange}
      min={MIN_VALUE}
      max={MAX_VALUE}
      step={VALUE_STEP}
    />
  );
};

export default LocationSelector;
